export const addLeadingZero = value => String(value).length > 1 ? value : `0${value}`;

export const formatTime = (date = new Date(), isUTC = false) => {
    const h = addLeadingZero(isUTC ? date.getUTCHours() : date.getHours());
    const m = addLeadingZero(isUTC ? date.getUTCMinutes() : date.getMinutes());
    const s = addLeadingZero(isUTC ? date.getUTCSeconds() : date.getSeconds());

    return `${h}:${m}:${s}`;
};

export const formatDate = (date = new Date()) => {
    const d = addLeadingZero(date.getDate());
    const m = addLeadingZero(date.getMonth() + 1);
    const y = date.getFullYear();

    return `${d}/${m}/${y}`;
};
